import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';

const FilterSchema = () => {
  const filters = useSelector((state: RootState) => state.teamLeadDashboard.allAgentsFilters);
  const allAgentsFiltersSchema = {
    agencyCode: {
      key: 'agencyCode',
      multiSelect: true,
      isSearchEnabled: false,
      label: 'Agency Code',
      options: filters[0]?.AGENCY_CODE || []
    },
    agentRole: {
      key: 'agentRole',
      multiSelect: true,
      isSearchEnabled: true,
      label: 'Agent Role',
      options: filters[1]?.AGENT_ROLE || []
    },
    bucketGroup: {
      key: 'bucketGroup',
      multiSelect: true,
      isSearchEnabled: true,
      label: 'Bucket Group',
      options: filters[2]?.BUCKET_GROUP || []
    },
    primaryLanguage: {
      key: 'primaryLanguage',
      multiSelect: true,
      isSearchEnabled: true,
      label: 'Primary Language',
      options: filters[3]?.PRIMARY_LANGUAGE || []
    },
    agentState: {
      key: 'agentState',
      multiSelect: true,
      isSearchEnabled: true,
      label: 'Agent State',
      options: filters[4]?.AGENT_STATE || []
    },
    status: {
      key: 'status',
      multiSelect: true,
      isSearchEnabled: false,
      label: 'Status',
      options: filters[5]?.STATUS || []
    }
  };
  return allAgentsFiltersSchema;
};

export default FilterSchema;
